'use client';
import { memo, useState } from 'react';
import { MediaBrowser, type SelectedImage } from './media-browser';
import { FieldLabel } from '@measured/puck';

export const UploadFile = memo(
  ({
    mimeTypes = [
      'image/png',
      'image/jpeg',
      'image/webp',
      'image/svg',
      'image/gif',
      'video/mp4',
      'image/svg+xml',
    ],
    defaultValue,
    onChange,
    label = 'Image',
  }: {
    mimeTypes?: string[];
    defaultValue?: SelectedImage;
    name: string;
    label?: string;
    onChange: (val?: SelectedImage) => void;
  }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [value, setValue] = useState<SelectedImage | undefined>(defaultValue);

    return (
      <div className='grid w-full max-w-sm items-center gap-1.5'>
        <FieldLabel label={label}>
          <div className='flex flex-col gap-1'>
            <div className='break-all text-xs'>{value?.url ?? ''}</div>
            <button
              onClick={() => setOpen(true)}
              className='text-brand m-0 w-auto p-0 text-start text-sm underline'
            >
              Pick from media browser
            </button>
          </div>
        </FieldLabel>

        <MediaBrowser
          mimeTypes={mimeTypes}
          isOpen={open}
          selectedValue={defaultValue}
          onOpenChange={setOpen}
          onItemSelected={(s) => {
            setValue(s);
            onChange(s);
            setOpen(false);
          }}
        ></MediaBrowser>
      </div>
    );
  }
);
